import React from 'react'
import { Link } from 'react-router-dom'
import trastorno_bipolar from '../assets/images/psicologo/trastorno_bipolar.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${trastorno_bipolar})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Trastorno bipolar</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Trastorno bipolar</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

   <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          El trastorno bipolar es una condición que provoca cambios inusuales en el estado de ánimo, la energía y los niveles de actividad. Las personas con este trastorno experimentan episodios de depresión y manía o hipomanía, que afectan su capacidad para llevar una vida estable.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el trastorno bipolar?</h4>
        <p className="text-muted">
          Implica alteraciones en la regulación de neurotransmisores y en la actividad de áreas cerebrales como la corteza prefrontal y el sistema límbico. Desde la neuromodulación, se busca estabilizar la actividad cerebral y reducir la frecuencia e intensidad de los episodios.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: cambios bruscos de energía, alteraciones del sueño (insomnio en manía, hipersomnia en depresión).
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: pensamientos acelerados o enlentecidos, dificultad para concentrarse.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: conductas impulsivas durante la manía, aislamiento social en depresión.
        </p>
        <br />
        
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): utilizada en fases depresivas para activar áreas cerebrales hipoactivas.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): modulaciones específicas según la fase del trastorno.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para mejorar la autorregulación emocional.
        </p>
      </div>
    </div>
  </div>
</section>
    
    <Footer/>
    </>
  )
}
